var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudioOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.765,
    height: 14.609,
    viewBox: "0 0 10.765 14.609",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 15633"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 15632"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13746",
    d: "M5.383 9.227a2.3 2.3 0 002.3-2.307l.008-4.613a2.307 2.307 0 10-4.613 0V6.92a2.308 2.308 0 002.305 2.307z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13747",
    d: "M9.457 6.92a4.078 4.078 0 01-8.15 0H0a5.364 5.364 0 004.613 5.167v2.522h1.538v-2.522a5.364 5.364 0 004.616-5.167z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioOn);
export default __webpack_public_path__ + "static/media/audio-on.7f60b255.svg";
export { ForwardRef as ReactComponent };